import { render, staticRenderFns } from "./CorrectMath.vue?vue&type=template&id=33b3b41c&scoped=true&lang=pug&"
import script from "./CorrectMath.vue?vue&type=script&lang=ts&"
export * from "./CorrectMath.vue?vue&type=script&lang=ts&"
import style0 from "./CorrectMath.vue?vue&type=style&index=0&id=33b3b41c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b3b41c",
  null
  
)

export default component.exports